import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f47ec490&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=f47ec490&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47ec490",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f47ec490')) {
      api.createRecord('f47ec490', component.options)
    } else {
      api.reload('f47ec490', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f47ec490&scoped=true", function () {
      api.rerender('f47ec490', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/contents/setting/index.vue"
export default component.exports